// Video frame thumbnails from GET /video_project/:id/frame_thumbnails/:ms.
// The API needs the auth header, so frames are fetched with axios and shown from object URLs.
import axios from "../../../components/Axios";

const MAX_IN_FLIGHT = 4;
const cache = new Map(); // "projectId:ms" -> Promise<objectURL | null>
const queue = [];
let inFlight = 0;
let broken = false; // after a server error, stop asking (avoid one error toast per scene)

function done() {
  inFlight--;
  next();
}

function next() {
  while (inFlight < MAX_IN_FLIGHT && queue.length) {
    const job = queue.shift();
    inFlight++;
    job().finally(done);
  }
}

/** object URL of the frame at ms, or null when there is none */
export function frameThumb(projectId, ms) {
  const key = projectId + ":" + ms;
  if (!cache.has(key)) {
    cache.set(
      key,
      new Promise((resolve) => {
        queue.push(() => {
          if (broken) {
            resolve(null);
            return Promise.resolve();
          }
          return axios
            .get("/video_project/" + projectId + "/frame_thumbnails/" + ms, {
              responseType: "blob",
              // 404 = no frame: an expected answer, not an error toast
              validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
            })
            .then((response) => resolve(response.status === 404 ? null : URL.createObjectURL(response.data)))
            .catch((error) => {
              if (!error.response || error.response.status >= 500) broken = true;
              resolve(null);
            });
        });
        next();
      })
    );
  }
  return cache.get(key);
}
